<template>
  <WdsStack gap-xs>
    <WdsTooltip
      :global="!fullscreen"
      :text="
        $tc(':count candidate for this job | :count candidates for this job', numberOfCandidates)
      "
    >
      <WdsTag :success="numberOfCandidates > 0">
        <WdsStack gap-xs justify-center align-center>
          <WdsIcon name="user" :size="16" />
          {{ numberOfCandidates }}
        </WdsStack>
      </WdsTag>
    </WdsTooltip>
    <WdsTooltip
      :global="!fullscreen"
      :text="
        $tc(
          ':count hire related to this job / :requiredWorkers required hire(s) | :count hires related to this job / :requiredWorkers required hire(s)',
          numberOfHires,
          { requiredWorkers: column.requiredWorkers ?? 0 },
        )
      "
    >
      <WdsTag :success="numberOfHires > 0">
        <WdsStack gap-xs justify-center align-center>
          <WdsIcon name="direct-hire" :size="16" />
          {{ numberOfHires }}
          / {{ column.requiredWorkers }}
        </WdsStack>
      </WdsTag>
    </WdsTooltip>
  </WdsStack>
</template>

<script lang="ts" setup>
import { computed, inject } from 'vue'
import { WdsIcon, WdsStack, WdsTag, WdsTooltip } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { $tc } from '@/composables/translation'
import { TableFullscreen } from '@/components/GraphqlDataTable/injection'

const JobCandidatesBidsHiresColumn = graphql(`
  fragment JobCandidatesBidsHiresColumn on Job {
    id
    workerCandidates: jobCandidates {
      paginatorInfo {
        total
      }
    }

    hires {
      paginatorInfo {
        total
      }
    }

    requiredWorkers
  }
`)

const fullscreen = inject(TableFullscreen)

const props = defineProps<{
  row: FragmentType<typeof JobCandidatesBidsHiresColumn>
}>()
const column = computed(() => useFragment(JobCandidatesBidsHiresColumn, props.row))
const numberOfCandidates = computed(() => column.value.workerCandidates.paginatorInfo.total)
const numberOfHires = computed(() => column.value.hires.paginatorInfo.total)
</script>

<style lang="scss"></style>
